/**
 * Created by florinia on 19/10/2017.
 */
import BaseComponent from '../../base/base_component';
import DOM from '../../utils/dom';
import ExternalLinksComponentContoller from '../../components/external_links/external_links_component_controller';
import * as EXTERNAL_LINKS_CONSTS from '../external_links/external_links_consts';
import ServiceFactory from '../../services/service_factory';

export default class RichComponentController extends BaseComponent {

    /**
     * @static
     * @type {string}
     */
    static CLASS = 'RichComponentController';

    /**
     * @static
     * @type {string}
     */
    static DIRECTIVE = 'cgp-rich-component';

    /**
     * Root component selector
     * @type {string}
     * @private
     */
    _selector = 'cgp-rich-component';

    /**
     * @param params
     */
    init(params) {
        super.init();
        this._setCampaignId(params);
    }

    /**
     * CampaignID parameter
     * @type {null}
     * @private
     */
    _campaignId = null;

    /**
     * Sets the value for private variable _campaignId
     * @param params
     * @private
     */
    _setCampaignId(params) {
        if (!params || !params.campaignid) {
            this.logger.error('CGP RICH directive requires campaignid parameter which was not provided');
        } else {
            this._campaignId = params.campaignid;
        }
    }

    /**
     * Start RICH feature behavior
     * @returns {RichComponentController}
     */
    start() {
        let externalLinkEl = this._state();
        this.render(externalLinkEl);
        return this;
    }

    /**
     * @returns {*}
     * @private
     */
    _state() {
        if (this._isRichPageAllowed()) {
            return this._openRichExternalLinksHandler();
        } else {
            let message = DOM.createElement('div');
            DOM.html(this.serviceFactory.languageService().translation('rich_user_not_logged_in'), message);
            return message;
        }
    }

    /**
     * @returns {*|string}
     * @private
     */
    _openRichExternalLinksHandler() {
        let externalLinkComponent = this.serviceFactory.componentFactoryService().createComponent(ExternalLinksComponentContoller, {
            source: EXTERNAL_LINKS_CONSTS.GNWP_SOURCES.RICH,
            type: EXTERNAL_LINKS_CONSTS.COMPONENT_TYPES.DIRECTIVE,
            options: {marketingCampaignId: this._campaignId}
        });

        externalLinkComponent.openLink();

        return externalLinkComponent.getEl();
    }

    /**
     * @returns {*|boolean|boolean}
     * @private
     */
    _isRichPageAllowed() {
        return ServiceFactory.create().oAuth2Service().isAuthorized();
    }
}


